import './index.scss'
$(".section4 ul li").eq(0).addClass("active");
$(".section4 .pic img").eq(0).addClass("active");
$(".section4 ul li").click(function() {
  let index = $(this).index();
  $(this).addClass("active").siblings().removeClass("active");
  $(".section4 .pic img").eq(index).addClass("active").siblings().removeClass("active");
})